import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useCallback } from 'react';
import { isFunction } from '../utils';
import useRefState from './use-ref-state';
import useUnmountedRef from './use-unmounted-ref';

var useSetState = function useSetState() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var unmountedRef = useUnmountedRef();

  var _useRefState = useRefState(initialState),
      _useRefState2 = _slicedToArray(_useRefState, 3),
      state = _useRefState2[0],
      setState = _useRefState2[1],
      ref = _useRefState2[2];

  var setMergeState = useCallback(function (patch) {
    if (unmountedRef.current) return;
    setState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), isFunction(patch) ? patch(prevState) : patch);
    });
  }, []);
  return [state, setMergeState, ref];
};

export default useSetState;